import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from '@material-ui/core/styles/withStyles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';
import classNames from 'classnames';

import messages from 'aurora-translations';
import styles from './styles';

function WorkflowStepper(props) {
  const { classes, steps, currentStep, handleNext, handleBack } = props;

  return (
    <Stepper
      nonLinear
      activeStep={currentStep}
      orientation='vertical'
      connector={<></>}
      classes={{
        vertical: classes.stepperopnerList,
      }}
    >
      {steps?.map((step, index) => (
        <Step key={step.key}>
          <StepButton
            onClick={() => {
              if (index + 1 === currentStep) return;
              index + 1 < currentStep ? handleBack(index + 1) : handleNext();
            }}
            completed={currentStep > index + 1}
            active={index + 1 === currentStep}
            classes={{ root: classNames({ [classes.stepButtonComplete]: currentStep > index + 1 }) }}
          >
            <StepLabel
              classes={{
                root: classes.MuiStepLabelRoot,
                label: classes.label,
                active: classes.labellistActive,
                iconContainer: classes.MuiStepLabeliconContainer,
              }}
              StepIconProps={{
                classes: {
                  root: classes.listingiconRoot,
                  text: classes.completed,
                  active: classes.activeIcon,
                },
              }}
            >
              {messages[step.title]?.id ? <FormattedMessage {...messages[step.title]} /> : step.title}
            </StepLabel>
          </StepButton>
        </Step>
      ))}
    </Stepper>
  );
}

WorkflowStepper.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.array.isRequired,
  currentStep: PropTypes.number,
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
};

WorkflowStepper.defaultProps = {
  workflow: {},
  currentStep: 0,
  children: null,
};

export default withStyles(styles)(WorkflowStepper);
